var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExternalAppsAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6475 7.23535H36.1181V31.5883H18.6475V7.23535Z",
    stroke: "#0067DF",
    strokeWidth: 3.32941,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3317 11.6665V10.0018H10.0023V11.6665H13.3317ZM10.0023 28.3332V29.9979H13.3317V28.3332H10.0023ZM10.0023 11.6665V28.3332H13.3317V11.6665H10.0023Z",
    fill: "#0067DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15494 13.3335V11.6688H3.82553V13.3335H7.15494ZM3.82553 26.6668V28.3315H7.15494V26.6668H3.82553ZM3.82553 13.3335V26.6668H7.15494V13.3335H3.82553Z",
    fill: "#0067DF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalAppsAdmin);
export default __webpack_public_path__ + "static/media/externalAppsAdmin.407e8dd23431a9b9b045fd923dd05971.svg";
export { ForwardRef as ReactComponent };